export { default } from './CaseStudies';



// WEBPACK FOOTER //
// ./src/components/templates/CaseStudies/index.js